import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      minHeight: '100vh',
      flexDirection: 'column',
      display: 'flex',
      maxWidth: '100%',
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10),
      [theme.breakpoints.down('sm')]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    },
    container: {
      flex: 'auto',
    },
  })
);

export default useStyles;
